<template>
  <router-view/>
</template>

<script>
export default {
  name: 'EventSchedule'
}
</script>

<style scoped>

</style>
